import {NDVSClient} from "../../client/NDVSClient";

export function printStoreReconciliationSheet(driversList, dispatcher) {
    console.log(driversList);
    NDVSClient.printStoreReconciliationSheet({
        driversList : driversList
    }).then(({valid, data}) => {
        if (valid) {
            const base64String = data.reconciliationSheetPdf;
            const blob = base64toBlob(base64String);

            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
        }
    });
}

const base64toBlob = (base64WithoutPrefix) => {
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: 'application/pdf'});
};




// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/network/PrintStoreReconciliationSheetAPI.js